"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8232,6818,7357],{

/***/ 60633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V7": function() { return /* reexport */ useArticleQuery; },
  "Im": function() { return /* reexport */ useCategoryQuery; }
});

// UNUSED EXPORTS: articleQuery, categoryQuery, fetchAllArticlesSlugs, fetchAllCategoriesSlugs, fetchGrowthCenterArticlesData, fetchGrowthCenterCategoriesData, fetchGrowthCenterData

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/richTextFromMarkdown/index.ts + 1 modules
var richTextFromMarkdown = __webpack_require__(14933);
// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ../../libs/api/routes/growthCenter/queries/growthCenterArticlesQuery.ts
/* provided dependency */ var process = __webpack_require__(34406);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var fetchGrowthCenterArticlesData = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var enabled, cachedFetch;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(["growthCenter/growthCenterArticlesQuery"], function () {
              return client.get("/content/rawEntries/growthCenterArticlePage").then(function (data) {
                var _data$items$map;

                return (_data$items$map = data.items.map(function (el) {
                  return el.fields;
                })) !== null && _data$items$map !== void 0 ? _data$items$map : null;
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchGrowthCenterArticlesData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchAllArticlesSlugs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var allArticles;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchGrowthCenterArticlesData(client);

          case 2:
            allArticles = _context2.sent;
            return _context2.abrupt("return", allArticles === null || allArticles === void 0 ? void 0 : allArticles.map(function (article) {
              var _article$category, _article$category$fie;

              return {
                slug: article === null || article === void 0 ? void 0 : article.slug,
                categorySlug: article === null || article === void 0 ? void 0 : (_article$category = article.category) === null || _article$category === void 0 ? void 0 : (_article$category$fie = _article$category.fields) === null || _article$category$fie === void 0 ? void 0 : _article$category$fie.slug
              };
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllArticlesSlugs(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var articleQuery = function articleQuery(client, articleSlug, categorySlug) {
  return [["growthCenter/articleQuery", articleSlug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var allArticles, articleData, newFaqs;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchGrowthCenterArticlesData(client);

          case 3:
            allArticles = _context4.sent;
            articleData = allArticles.find(function (s) {
              return s.slug === articleSlug && s.category.fields.slug === categorySlug;
            });

            if (!(articleData !== null && articleData !== void 0 && articleData.faqs)) {
              _context4.next = 10;
              break;
            }

            _context4.next = 8;
            return Promise.all(articleData === null || articleData === void 0 ? void 0 : articleData.faqs.map( /*#__PURE__*/function () {
              var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(faq) {
                var answer;
                return regenerator_default().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return (0,richTextFromMarkdown/* default */.Z)(String(faq.fields.answer) || "");

                      case 2:
                        answer = _context3.sent;
                        return _context3.abrupt("return", _objectSpread(_objectSpread({}, faq), {}, {
                          fields: {
                            question: faq.fields.question,
                            answer: answer
                          }
                        }));

                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x3) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 8:
            newFaqs = _context4.sent;
            articleData.faqs = newFaqs;

          case 10:
            if (articleData) {
              _context4.next = 12;
              break;
            }

            throw new Error("Article data is empty");

          case 12:
            return _context4.abrupt("return", articleData);

          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find article with ".concat(articleSlug, ".\nUnderlying error: ").concat(_context4.t0));

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 15]]);
  }))];
};
var useArticleQuery = (0,createQueryHook/* default */.Z)(articleQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/growthCenter/queries/growthCenterCategoriesQuery.ts
/* provided dependency */ var growthCenterCategoriesQuery_process = __webpack_require__(34406);



function growthCenterCategoriesQuery_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function growthCenterCategoriesQuery_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? growthCenterCategoriesQuery_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : growthCenterCategoriesQuery_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var fetchGrowthCenterCategoriesData = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var enabled, cachedFetch;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(growthCenterCategoriesQuery_process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(["growthCenter/growthCenterCategoriesQuery"], function () {
              return client.get("/content/rawEntries/growthCenterCategoryPage").then(function (data) {
                var _data$items$map;

                return (_data$items$map = data.items.map(function (el) {
                  return el.fields;
                })) !== null && _data$items$map !== void 0 ? _data$items$map : null;
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchGrowthCenterCategoriesData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchAllCategoriesSlugs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var allCategories;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchGrowthCenterCategoriesData(client);

          case 2:
            allCategories = _context2.sent;
            return _context2.abrupt("return", allCategories === null || allCategories === void 0 ? void 0 : allCategories.map(function (category) {
              return category === null || category === void 0 ? void 0 : category.slug;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllCategoriesSlugs(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var categoryQuery = function categoryQuery(client, categorySlug) {
  return [["growthCenter/categoryQuery", categorySlug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var allCategories, categoryData, newFaqs;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchGrowthCenterCategoriesData(client);

          case 3:
            allCategories = _context4.sent;
            categoryData = allCategories.find(function (s) {
              return s.slug === categorySlug;
            });

            if (!(categoryData !== null && categoryData !== void 0 && categoryData.faqs)) {
              _context4.next = 10;
              break;
            }

            _context4.next = 8;
            return Promise.all(categoryData === null || categoryData === void 0 ? void 0 : categoryData.faqs.map( /*#__PURE__*/function () {
              var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(faq) {
                var answer;
                return regenerator_default().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return (0,richTextFromMarkdown/* default */.Z)(String(faq.fields.answer) || "");

                      case 2:
                        answer = _context3.sent;
                        return _context3.abrupt("return", growthCenterCategoriesQuery_objectSpread(growthCenterCategoriesQuery_objectSpread({}, faq), {}, {
                          fields: {
                            question: faq.fields.question,
                            answer: answer
                          }
                        }));

                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x3) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 8:
            newFaqs = _context4.sent;
            categoryData.faqs = newFaqs;

          case 10:
            if (!(categoryData !== null && categoryData !== void 0 && categoryData.definition)) {
              _context4.next = 14;
              break;
            }

            _context4.next = 13;
            return (0,richTextFromMarkdown/* default */.Z)(String(categoryData === null || categoryData === void 0 ? void 0 : categoryData.definition) || "");

          case 13:
            categoryData.definition = _context4.sent;

          case 14:
            if (categoryData) {
              _context4.next = 16;
              break;
            }

            throw new Error("Category data is empty");

          case 16:
            return _context4.abrupt("return", categoryData);

          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find category with ".concat(categorySlug, ".\nUnderlying error: ").concat(_context4.t0));

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 19]]);
  }))];
};
var useCategoryQuery = (0,createQueryHook/* default */.Z)(categoryQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/growthCenter/queries/growthCenterDataQuery.ts
/* provided dependency */ var growthCenterDataQuery_process = __webpack_require__(34406);



var fetchGrowthCenterData = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(growthCenterDataQuery_process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(["growthCenter/growthCenterDataQuery"], function () {
              return client.get("/content/rawEntries/growthCenterLandingPage").then(function (data) {
                var _data$items$0$fields, _data$items, _data$items$;

                return (_data$items$0$fields = (_data$items = data.items) === null || _data$items === void 0 ? void 0 : (_data$items$ = _data$items[0]) === null || _data$items$ === void 0 ? void 0 : _data$items$.fields) !== null && _data$items$0$fields !== void 0 ? _data$items$0$fields : null;
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchGrowthCenterData(_x) {
    return _ref.apply(this, arguments);
  };
}()));
;// CONCATENATED MODULE: ../../libs/api/routes/growthCenter/queries/index.ts




/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58943);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useQuery
 */

var createQueryHook = function createQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery.apply */ .a.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createQueryHook);

/***/ }),

/***/ 10715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ createFsCacheProxy; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95922);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12741);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* module decorator */ module = __webpack_require__.hmd(module);




function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}



function _asyncIterator(iterable) {
  var method,
      async,
      sync,
      retry = 2;

  for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) {
    if (async && null != (method = iterable[async])) return method.call(iterable);
    if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
    async = "@@asyncIterator", sync = "@@iterator";
  }

  throw new TypeError("Object is not async iterable");
}

function AsyncFromSyncIterator(s) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var done = r.done;
    return Promise.resolve(r.value).then(function (value) {
      return {
        value: value,
        done: done
      };
    });
  }

  return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) {
    this.s = s, this.n = s.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function next() {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    "return": function _return(value) {
      var ret = this.s["return"];
      return void 0 === ret ? Promise.resolve({
        value: value,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
    },
    "throw": function _throw(value) {
      var thr = this.s["return"];
      return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(s);
}

function maybeImport(_x) {
  return _maybeImport.apply(this, arguments);
}

function _maybeImport() {
  _maybeImport = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(importFn) {
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return",  false ? 0 : Promise.resolve(null));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _maybeImport.apply(this, arguments);
}

function getPkgJsonDir() {
  return _getPkgJsonDir.apply(this, arguments);
}

function _getPkgJsonDir() {
  _getPkgJsonDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
    var _yield$import, dirname, _yield$import2, constants, access, errors, _iterator3, _step3, path, prospectivePkgJsonDir;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            _yield$import = _context4.sent;
            dirname = _yield$import.dirname;
            _context4.next = 6;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 6:
            _yield$import2 = _context4.sent;
            constants = _yield$import2.constants;
            access = _yield$import2.promises.access;
            errors = [];
            _iterator3 = _createForOfIteratorHelper(module.paths);
            _context4.prev = 11;

            _iterator3.s();

          case 13:
            if ((_step3 = _iterator3.n()).done) {
              _context4.next = 27;
              break;
            }

            path = _step3.value;
            _context4.prev = 15;
            prospectivePkgJsonDir = dirname(path); // eslint-disable-next-line no-await-in-loop

            _context4.next = 19;
            return access(path, constants.F_OK);

          case 19:
            return _context4.abrupt("return", prospectivePkgJsonDir);

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](15);
            errors.push(_context4.t0);

          case 25:
            _context4.next = 13;
            break;

          case 27:
            _context4.next = 32;
            break;

          case 29:
            _context4.prev = 29;
            _context4.t1 = _context4["catch"](11);

            _iterator3.e(_context4.t1);

          case 32:
            _context4.prev = 32;

            _iterator3.f();

            return _context4.finish(32);

          case 35:
            throw new Error("Cannot find project root dir. Underlying errors:\n\n ".concat(errors.join("\n")));

          case 36:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[11, 29, 32, 35], [15, 22]]);
  }));
  return _getPkgJsonDir.apply(this, arguments);
}

function getCacheFilename(_x2) {
  return _getCacheFilename.apply(this, arguments);
}

function _getCacheFilename() {
  _getCacheFilename = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(key) {
    var indexKey, hashData, _key, head, tail, hashPart, crypto, hashFn, hash;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!key.length && key.length <= 0)) {
              _context5.next = 2;
              break;
            }

            throw new Error("Cache key is empty");

          case 2:
            hashData = null;

            if (Array.isArray(key)) {
              _key = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(key), head = _key[0], tail = _key.slice(1);
              indexKey = head;
              hashData = tail;
            } else {
              indexKey = key;
            }

            hashPart = "";

            if (!(hashData && hashData.length > 0)) {
              _context5.next = 12;
              break;
            }

            _context5.next = 8;
            return maybeImport(function () {
              return Promise.all(/* import() */[__webpack_require__.e(8934), __webpack_require__.e(8834), __webpack_require__.e(8421)]).then(__webpack_require__.t.bind(__webpack_require__, 71941, 23));
            });

          case 8:
            crypto = _context5.sent;
            hashFn = crypto === null || crypto === void 0 ? void 0 : crypto.createHash("sha1");
            hash = hashFn === null || hashFn === void 0 ? void 0 : hashFn.update(hashData.map(function (v) {
              return typeof v === "string" ? v : JSON.stringify(v);
            }).join("")).digest("hex");

            if (hash) {
              hashPart = "-".concat(hash);
            }

          case 12:
            return _context5.abrupt("return", "".concat(indexKey).concat(hashPart));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getCacheFilename.apply(this, arguments);
}

function getDefaultCacheDirPath() {
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function _getDefaultCacheDirPath() {
  _getDefaultCacheDirPath = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
    var path;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context6.sent;
            _context6.t0 = path;
            _context6.next = 6;
            return getPkgJsonDir();

          case 6:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.resolve.call(_context6.t0, _context6.t1, "node_modules/.cache/fsCache"));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function invariantCacheFilePresent(_x3) {
  return _invariantCacheFilePresent.apply(this, arguments);
}

function _invariantCacheFilePresent() {
  _invariantCacheFilePresent = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(cacheFilePath) {
    var _yield$import3, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import3 = _context7.sent;
            constants = _yield$import3.constants;
            fs = _yield$import3.promises;
            _context7.next = 7;
            return fs.access(cacheFilePath, constants.F_OK);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _invariantCacheFilePresent.apply(this, arguments);
}

function ensureCacheDirExists(_x4) {
  return _ensureCacheDirExists.apply(this, arguments);
}

function _ensureCacheDirExists() {
  _ensureCacheDirExists = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(cacheDirPath) {
    var _yield$import4, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import4 = _context8.sent;
            constants = _yield$import4.constants;
            fs = _yield$import4.promises;
            _context8.prev = 5;
            _context8.next = 8;
            return fs.access(cacheDirPath, constants.F_OK);

          case 8:
            _context8.next = 18;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](5);

            if (!(_context8.t0.code === "ENOENT")) {
              _context8.next = 17;
              break;
            }

            _context8.next = 15;
            return fs.mkdir(cacheDirPath, {
              recursive: true
            });

          case 15:
            _context8.next = 18;
            break;

          case 17:
            throw _context8.t0;

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[5, 10]]);
  }));
  return _ensureCacheDirExists.apply(this, arguments);
}

function isCacheStale(metadata, staleTime) {
  return metadata.time - Date.now() + staleTime * 1000 < 0;
}

function loadCacheMetadata(_x5) {
  return _loadCacheMetadata.apply(this, arguments);
}

function _loadCacheMetadata() {
  _loadCacheMetadata = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(cacheFilePath) {
    var fs, readline, readable, readInterface, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context9.sent;
            _context9.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context9.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            }); // eslint-disable-next-line no-unreachable-loop

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context9.prev = 10;
            _iterator = _asyncIterator(readInterface);

          case 12:
            _context9.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context9.sent).done)) {
              _context9.next = 20;
              break;
            }

            line = _step.value;
            return _context9.abrupt("return", JSON.parse(line));

          case 17:
            _iteratorAbruptCompletion = false;
            _context9.next = 12;
            break;

          case 20:
            _context9.next = 26;
            break;

          case 22:
            _context9.prev = 22;
            _context9.t0 = _context9["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context9.t0;

          case 26:
            _context9.prev = 26;
            _context9.prev = 27;

            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return _iterator["return"]();

          case 31:
            _context9.prev = 31;

            if (!_didIteratorError) {
              _context9.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context9.finish(31);

          case 35:
            return _context9.finish(26);

          case 36:
            throw new Error("Cannot load cache metadata");

          case 37:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 22, 26, 36], [27,, 31, 35]]);
  }));
  return _loadCacheMetadata.apply(this, arguments);
}

function loadCachedData(_x6) {
  return _loadCachedData.apply(this, arguments);
}

function _loadCachedData() {
  _loadCachedData = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(cacheFilePath) {
    var fs, readline, readable, readInterface, data, isFirstLine, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context10.sent;
            _context10.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context10.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            });
            data = "";
            isFirstLine = true;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context10.prev = 12;
            _iterator2 = _asyncIterator(readInterface);

          case 14:
            _context10.next = 16;
            return _iterator2.next();

          case 16:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context10.sent).done)) {
              _context10.next = 25;
              break;
            }

            line = _step2.value;

            if (!isFirstLine) {
              _context10.next = 21;
              break;
            }

            isFirstLine = false;
            return _context10.abrupt("continue", 22);

          case 21:
            data += line;

          case 22:
            _iteratorAbruptCompletion2 = false;
            _context10.next = 14;
            break;

          case 25:
            _context10.next = 31;
            break;

          case 27:
            _context10.prev = 27;
            _context10.t0 = _context10["catch"](12);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 31:
            _context10.prev = 31;
            _context10.prev = 32;

            if (!(_iteratorAbruptCompletion2 && _iterator2["return"] != null)) {
              _context10.next = 36;
              break;
            }

            _context10.next = 36;
            return _iterator2["return"]();

          case 36:
            _context10.prev = 36;

            if (!_didIteratorError2) {
              _context10.next = 39;
              break;
            }

            throw _iteratorError2;

          case 39:
            return _context10.finish(36);

          case 40:
            return _context10.finish(31);

          case 41:
            return _context10.abrupt("return", JSON.parse(data));

          case 42:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _loadCachedData.apply(this, arguments);
}

function isSubDir(_x7, _x8) {
  return _isSubDir.apply(this, arguments);
}
/**
 * Creates a file system cache function proxy. It stores function results in the
 * file system and reuses them as long as they are fresh. Useful to cache heavy
 * network requests while building static page via NextJS. Each function with
 * unique key is stored as a separate entry in a location set via options.
 *
 * @param key - globally unique caching key
 * @param fn - fetching function which returned data will be cached
 * @param opts - options object
 * @returns function proxy with caching layer
 */


function _isSubDir() {
  _isSubDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(parent, dir) {
    var path, relative;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context11.sent;
            relative = path.relative(parent, dir);
            return _context11.abrupt("return", relative && !relative.startsWith("..") && !path.isAbsolute(relative));

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _isSubDir.apply(this, arguments);
}

var createFsCacheProxy = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(key, fn, _ref) {
    var enabled, _ref$staleTime, staleTime, _ref$cacheDirPath, userCacheDirPath, fsClassic, path, fs, cacheDirPath, cacheFilename, cacheFilePath, targetCacheDirPath;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = _ref.enabled, _ref$staleTime = _ref.staleTime, staleTime = _ref$staleTime === void 0 ? 300 : _ref$staleTime, _ref$cacheDirPath = _ref.cacheDirPath, userCacheDirPath = _ref$cacheDirPath === void 0 ? "/workdir/apps/segment/node_modules/.cache/fsCache" : _ref$cacheDirPath;
            _context2.next = 3;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));
            });

          case 3:
            fsClassic = _context2.sent;
            _context2.next = 6;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));
            });

          case 6:
            path = _context2.sent;

            if (!(!fsClassic || !path || !enabled || true)) {}

            return _context2.abrupt("return", fn);

          case 9:
            fs = fsClassic.promises;
            _context2.t0 = path;

            if (!(userCacheDirPath !== null && userCacheDirPath !== void 0)) {
              _context2.next = 15;
              break;
            }

            _context2.t1 = userCacheDirPath;
            _context2.next = 18;
            break;

          case 15:
            _context2.next = 17;
            return getDefaultCacheDirPath();

          case 17:
            _context2.t1 = _context2.sent;

          case 18:
            _context2.t2 = _context2.t1;
            cacheDirPath = _context2.t0.resolve.call(_context2.t0, _context2.t2);
            _context2.next = 22;
            return getCacheFilename(key);

          case 22:
            cacheFilename = _context2.sent;
            cacheFilePath = path.resolve(cacheDirPath, cacheFilename);
            targetCacheDirPath = path.dirname(cacheFilePath);
            _context2.t3 = cacheDirPath !== targetCacheDirPath;

            if (!_context2.t3) {
              _context2.next = 30;
              break;
            }

            _context2.next = 29;
            return isSubDir(cacheDirPath, targetCacheDirPath);

          case 29:
            _context2.t3 = !_context2.sent;

          case 30:
            if (!_context2.t3) {
              _context2.next = 32;
              break;
            }

            throw new Error("Cache file tries to jailbreak cache dir. Make sure that cache key doesn't start with eg. \"../\".");

          case 32:
            return _context2.abrupt("return", new Proxy(fn, {
              apply: function apply(target, _that, args) {
                return (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                  var metadata, isCacheStaleValue, result, newCacheMetadata, stringifiedMetadata, dataToCache, cachePayload;
                  return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return invariantCacheFilePresent(cacheFilePath);

                        case 3:
                          _context.next = 5;
                          return loadCacheMetadata(cacheFilePath);

                        case 5:
                          metadata = _context.sent;
                          _context.next = 8;
                          return isCacheStale(metadata, staleTime);

                        case 8:
                          isCacheStaleValue = _context.sent;

                          if (isCacheStaleValue) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return", loadCachedData(cacheFilePath));

                        case 11:
                          _context.next = 15;
                          break;

                        case 13:
                          _context.prev = 13;
                          _context.t0 = _context["catch"](0);

                        case 15:
                          _context.next = 17;
                          return target.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));

                        case 17:
                          result = _context.sent;
                          newCacheMetadata = {
                            time: Date.now()
                          };
                          stringifiedMetadata = JSON.stringify(newCacheMetadata);
                          _context.prev = 20;
                          dataToCache = JSON.stringify(result);
                          _context.next = 27;
                          break;

                        case 24:
                          _context.prev = 24;
                          _context.t1 = _context["catch"](20);
                          throw new Error("Failed to JSON stringify result. Caching only supported for simple data.\n\n Inner exception: \n".concat(dataToCache));

                        case 27:
                          cachePayload = stringifiedMetadata + "\n" + dataToCache;
                          _context.next = 30;
                          return ensureCacheDirExists(targetCacheDirPath);

                        case 30:
                          _context.next = 32;
                          return fs.writeFile(cacheFilePath, cachePayload, {
                            encoding: "utf8"
                          });

                        case 32:
                          return _context.abrupt("return", result);

                        case 33:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 13], [20, 24]]);
                }))();
              }
            }));

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createFsCacheProxy(_x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 96904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* reexport safe */ _fsCache__WEBPACK_IMPORTED_MODULE_0__.c; }
/* harmony export */ });
/* harmony import */ var _fsCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10715);


/***/ }),

/***/ 14933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ richTextFromMarkdown_richTextFromMarkdown; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(35838);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
// EXTERNAL MODULE: ../../node_modules/lodash/flatten.js
var flatten = __webpack_require__(35676);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ../../node_modules/lodash/isArray.js
var isArray = __webpack_require__(86152);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/unified/lib/index.js + 9 modules
var lib = __webpack_require__(2359);
// EXTERNAL MODULE: ../../node_modules/remark-parse/lib/index.js + 38 modules
var remark_parse_lib = __webpack_require__(50480);
// EXTERNAL MODULE: ../../node_modules/remark-gfm/index.js + 33 modules
var remark_gfm = __webpack_require__(85977);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ../../libs/utils/richTextFromMarkdown/richTextFromMarkdown.ts







function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var markdownNodeTypes = new Map([["paragraph", dist.BLOCKS.PARAGRAPH], ["heading", "heading"], ["text", "text"], ["emphasis", "text"], ["strong", "text"], ["delete", "text"], ["inlineCode", "text"], ["link", dist.INLINES.HYPERLINK], ["thematicBreak", dist.BLOCKS.HR], ["blockquote", dist.BLOCKS.QUOTE], ["list", "list"], ["listItem", dist.BLOCKS.LIST_ITEM], ["table", dist.BLOCKS.TABLE], ["tableRow", dist.BLOCKS.TABLE_ROW], ["tableCell", dist.BLOCKS.TABLE_CELL]]);

var nodeTypeFor = function nodeTypeFor(node) {
  var nodeType = markdownNodeTypes.get(node.type);

  if (isHeading(node)) {
    return "".concat(nodeType, "-").concat(node.depth);
  }

  if (isList(node)) {
    return "".concat(node.ordered ? "ordered" : "unordered", "-list");
  }

  return nodeType !== null && nodeType !== void 0 ? nodeType : node.type;
};

var isList = function isList(node) {
  return node.type === "list";
};

var isHeading = function isHeading(node) {
  return node.type === "heading";
};

var isLink = function isLink(node) {
  return node.type === "link";
};

var isTableCell = function isTableCell(node) {
  return node.type === "tableCell";
};

var isBlock = function isBlock(node) {
  return nodeContainerTypes.get(nodeTypeFor(node)) === "block";
};

var isText = function isText(node) {
  return nodeContainerTypes.get(nodeTypeFor(node)) === "text";
};

var isInline = function isInline(node) {
  return nodeContainerTypes.get(nodeTypeFor(node)) === "inline";
};

var markTypes = new Map([["emphasis", "italic"], ["strong", "bold"], ["inlineCode", "code"]]);

var markTypeFor = function markTypeFor(node) {
  return markTypes.get(node.type);
};

var nodeContainerTypes = new Map([["delete", "block"], [dist.BLOCKS.HEADING_1, "block"], [dist.BLOCKS.HEADING_2, "block"], [dist.BLOCKS.HEADING_3, "block"], [dist.BLOCKS.HEADING_4, "block"], [dist.BLOCKS.HEADING_5, "block"], [dist.BLOCKS.HEADING_6, "block"], [dist.BLOCKS.LIST_ITEM, "block"], [dist.BLOCKS.UL_LIST, "block"], [dist.BLOCKS.OL_LIST, "block"], [dist.BLOCKS.QUOTE, "block"], [dist.BLOCKS.HR, "block"], [dist.BLOCKS.PARAGRAPH, "block"], [dist.BLOCKS.TABLE, "block"], [dist.BLOCKS.TABLE_CELL, "block"], [dist.BLOCKS.TABLE_HEADER_CELL, "block"], [dist.BLOCKS.TABLE_ROW, "block"], [dist.INLINES.HYPERLINK, "inline"], ["text", "text"], ["emphasis", "text"], ["strong", "text"], ["inlineCode", "text"]]);

var buildHyperlink = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(node, fallback, appliedMarksTypes) {
    var content, hyperlink;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return mdToRichTextNodes(node.children, fallback, appliedMarksTypes);

          case 2:
            content = _context.sent;
            hyperlink = {
              nodeType: dist.INLINES.HYPERLINK,
              data: {
                uri: node.url
              },
              content: content
            };
            return _context.abrupt("return", [hyperlink]);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function buildHyperlink(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var buildGenericBlockOrInline = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(node, fallback, appliedMarksTypes) {
    var nodeType, content;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            nodeType = nodeTypeFor(node);
            _context2.next = 3;
            return mdToRichTextNodes(node.children, fallback, appliedMarksTypes);

          case 3:
            content = _context2.sent;
            return _context2.abrupt("return", [{
              nodeType: nodeType,
              content: content,
              data: {}
            }]);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function buildGenericBlockOrInline(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var buildTableCell = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(node, fallback, appliedMarksTypes) {
    var nodeChildren, content;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return mdToRichTextNodes(node.children, fallback, appliedMarksTypes);

          case 2:
            nodeChildren = _context3.sent;
            content = nodeChildren.map(function (contentNode) {
              return {
                nodeType: dist.BLOCKS.PARAGRAPH,
                data: {},
                content: [contentNode]
              };
            }); // A table cell can't be empty

            if (content.length === 0) {
              content.push({
                nodeType: dist.BLOCKS.PARAGRAPH,
                data: {},
                content: [{
                  nodeType: "text",
                  data: {},
                  marks: [],
                  value: ""
                }]
              });
            }
            /**
             * We should only support texts inside table cells.
             * Some markdowns might contain html inside tables such as <ul>, <blockquote>, etc
             * but they are pretty much filtered out by markdownNodeTypes and nodeContainerTypes variables.
             * so we ended up receiving only `text` nodes.
             * We can't have table cells with text nodes directly, we must wrap text nodes inside paragraphs.
             */


            return _context3.abrupt("return", [{
              nodeType: dist.BLOCKS.TABLE_CELL,
              content: content,
              data: {}
            }]);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function buildTableCell(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

var buildText = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(node, fallback, appliedMarksTypes) {
    var nodeType, markType, marks;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            nodeType = nodeTypeFor(node);
            markType = markTypeFor(node);
            marks = (0,toConsumableArray/* default */.Z)(appliedMarksTypes);

            if (markType) {
              marks.push(markType);
            }

            if (!(node.type !== "text" && node.type !== "inlineCode")) {
              _context4.next = 8;
              break;
            }

            _context4.next = 7;
            return mdToRichTextNodes(node.children, fallback, marks);

          case 7:
            return _context4.abrupt("return", _context4.sent);

          case 8:
            return _context4.abrupt("return", [{
              nodeType: nodeType,
              value: node.value,
              marks: marks.map(function (type) {
                return {
                  type: type
                };
              }),
              data: {}
            }]);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function buildText(_x10, _x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();

var buildFallbackNode = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(node, fallback) {
    var fallbackResult;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fallback(node);

          case 2:
            fallbackResult = _context5.sent;

            if (!isArray_default()(fallbackResult)) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", fallbackResult);

          case 5:
            return _context5.abrupt("return", [fallbackResult]);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function buildFallbackNode(_x13, _x14) {
    return _ref5.apply(this, arguments);
  };
}();

function mdToRichTextNode(_x15, _x16) {
  return _mdToRichTextNode.apply(this, arguments);
}

function _mdToRichTextNode() {
  _mdToRichTextNode = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(node, fallback) {
    var appliedMarksTypes,
        _args7 = arguments;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            appliedMarksTypes = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : [];

            if (!isLink(node)) {
              _context7.next = 3;
              break;
            }

            return _context7.abrupt("return", buildHyperlink(node, fallback, appliedMarksTypes));

          case 3:
            if (!isTableCell(node)) {
              _context7.next = 5;
              break;
            }

            return _context7.abrupt("return", buildTableCell(node, fallback, appliedMarksTypes));

          case 5:
            if (!(isBlock(node) || isInline(node))) {
              _context7.next = 7;
              break;
            }

            return _context7.abrupt("return", buildGenericBlockOrInline(node, fallback, appliedMarksTypes));

          case 7:
            if (!isText(node)) {
              _context7.next = 9;
              break;
            }

            return _context7.abrupt("return", buildText(node, fallback, appliedMarksTypes));

          case 9:
            return _context7.abrupt("return", buildFallbackNode(node, fallback));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _mdToRichTextNode.apply(this, arguments);
}

function mdToRichTextNodes(_x17, _x18) {
  return _mdToRichTextNodes.apply(this, arguments);
}

function _mdToRichTextNodes() {
  _mdToRichTextNodes = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(nodes, fallback) {
    var appliedMarksTypes,
        rtNodes,
        _args8 = arguments;
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            appliedMarksTypes = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : [];

            if (nodes) {
              _context8.next = 3;
              break;
            }

            return _context8.abrupt("return", Promise.resolve([]));

          case 3:
            _context8.next = 5;
            return Promise.all(nodes.map(function (node) {
              return mdToRichTextNode(node, fallback, appliedMarksTypes);
            }));

          case 5:
            rtNodes = _context8.sent;
            return _context8.abrupt("return", flatten_default()(rtNodes).filter(Boolean));

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _mdToRichTextNodes.apply(this, arguments);
}

var astToRichTextDocument = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(tree, fallback) {
    var content;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return mdToRichTextNodes(tree.children, fallback);

          case 2:
            content = _context6.sent;
            return _context6.abrupt("return", {
              nodeType: dist.BLOCKS.DOCUMENT,
              data: {},
              content: content
            });

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function astToRichTextDocument(_x19, _x20) {
    return _ref6.apply(this, arguments);
  };
}();

function expandParagraphWithInlineImages(node) {
  if (node.type !== "paragraph") {
    return [node];
  }

  var imageNodeIndices = [];

  for (var i = 0; i < node.children.length; i++) {
    if (node.children[i].type === "image") {
      imageNodeIndices.push(i);
    }
  }

  if (imageNodeIndices.length === 0) {
    // If no images in children, return.
    return [node];
  }

  var allNodes = [];
  var lastIndex = -1;

  for (var j = 0; j < imageNodeIndices.length; j++) {
    var index = imageNodeIndices[j]; // Before

    if (index !== 0) {
      var nodesBefore = node.children.slice(lastIndex + 1, index);

      if (nodesBefore.length > 0) {
        allNodes.push(_objectSpread(_objectSpread({}, node), {}, {
          children: nodesBefore
        }));
      }
    } // Image


    var imageNode = node.children[index];
    allNodes.push(imageNode); // Till end

    var nodesAfter = [];
    var rangeEnd = j + 1 < imageNodeIndices.length ? imageNodeIndices[j + 1] : node.children.length;

    if (index + 1 < rangeEnd && index === imageNodeIndices.slice(-1)[0]) {
      nodesAfter = node.children.slice(index + 1, rangeEnd);

      if (nodesAfter.length > 0) {
        allNodes.push(_objectSpread(_objectSpread({}, node), {}, {
          children: nodesAfter
        }));
      }
    }

    lastIndex = index;
  }

  return allNodes;
}

var isParent = function isParent(node) {
  return "children" in node;
}; // Inline markdown images come in as nested within a MarkdownNode paragraph
// so we must hoist them out before transforming to rich text.


function prepareMdAST(ast) {
  function prepareASTNodeChildren(node) {
    if (!isParent(node)) {
      return node;
    }

    var children = flatMap_default()(node.children, function (n) {
      return expandParagraphWithInlineImages(n);
    }).map(function (n) {
      return prepareASTNodeChildren(n);
    });

    return _objectSpread(_objectSpread({}, node), {}, {
      children: children
    });
  }

  return prepareASTNodeChildren(ast);
} // COMPAT: can resolve with either Node or an array of Nodes for back compatibility.


function richTextFromMarkdown(_x21) {
  return _richTextFromMarkdown.apply(this, arguments);
}

function _richTextFromMarkdown() {
  _richTextFromMarkdown = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(md) {
    var fallback,
        processor,
        tree,
        ast,
        _args9 = arguments;
    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            fallback = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : function () {
              return Promise.resolve(null);
            };
            processor = (0,lib/* unified */.l)().use(remark_parse_lib/* default */.Z).use(remark_gfm/* default */.Z);
            tree = processor.parse(md);
            ast = prepareMdAST(tree);
            return _context9.abrupt("return", astToRichTextDocument(ast, fallback));

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _richTextFromMarkdown.apply(this, arguments);
}

/* harmony default export */ var richTextFromMarkdown_richTextFromMarkdown = (richTextFromMarkdown);
;// CONCATENATED MODULE: ../../libs/utils/richTextFromMarkdown/index.ts


/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

}]);